import React, { useCallback, useState } from "react";
import "./ProducerHub.scss";
import { useUser } from "contexts/UserContext";
import locationOutlined from "@assets/icons/location-marker.svg";
import globeOutlined from "@assets/icons/globe-alt.svg";
import sizeOutlined from "@assets/icons/Size.svg";
import { Avatar, Button, Rate } from "antd";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import Overview from "@containers/Overview/Overview";
import MyProduct from "@containers/MyProduct/MyProduct";

const ProducerHub: React.FC = () => {
  const [activeTab, setActiveTab] = useState(1);
  const { userProfile, userAddresses } = useUser();

  const menuBtn = [
    {
      id: 1,
      title: "Overview",
    },
    {
      id: 2,
      title: "Product",
    },
    {
      id: 3,
      title: "Order",
    },
  ];

  const getUserAddress = useCallback(() => {
    if (!userProfile?.address_id) return;
    const address = userAddresses.find(
      (item: any) => item.address_id === userProfile?.address_id
    );
    return address;
  }, [userProfile?.address_id]);

  return (
    <div className="ProducerHub">
      <div className="producer-head">
        {/* <div className="producer-banner">
          {userProfile?.farm_info.banner ? (
            <img src={userProfile?.farm_info.banner!} alt="banner" />
          ) : (
            <div
              style={{
                width: "100%",
                height: "259.04px",
                backgroundColor: "#cecece",
              }}
            ></div>
          )}
        </div> */}
        <div className="container">
          <div className="avatar-wrap-position">
            <div className="avatar-wrap">
              {userProfile?.farm_info?.avatar ||
              userProfile?.farm_info?.avatar !== "" ? (
                <Avatar
                  size={100}
                  src={userProfile?.farm_info.avatar}
                  className="farm-avatar"
                />
              ) : (
                <Avatar className="farm-avatar-default">
                  {userProfile?.farm_info.farm_name
                    ? userProfile?.farm_info.farm_name[0].toUpperCase()
                    : "F"}
                </Avatar>
              )}
            </div>
            <div className="main-head">
              <div className="farm-name">
                {userProfile?.farm_info.farm_name}
                <span>#6 in Leaderboard</span>
              </div>
              <div className="farm-rating">
                <Rate disabled defaultValue={5} className="rate" /> 5.0
              </div>
              <div className="farm-info">
                <div className="farm-info-item">
                  <img src={sizeOutlined} alt="size" />
                  <span>{userProfile?.farm_info.farm_size} acres</span>
                </div>
                <div className="farm-info-item">
                  <img src={locationOutlined} alt="location" />
                  <span>{getUserAddress()?.street}</span>
                </div>

                <div className="farm-info-item website">
                  <img src={globeOutlined} alt="globe" />
                  <span
                    onClick={() => {
                      userProfile?.farm_info.website &&
                        window.open(
                          `https://${userProfile?.farm_info.website}`
                        );
                    }}
                  >
                    {userProfile?.farm_info.website}
                  </span>
                </div>
              </div>
            </div>
            <div className="hub-action">
              <Button className="view-as-btn" icon={<EyeOutlined />}>
                View as Buyer
              </Button>
              <Button className="edit-btn" icon={<EditOutlined />}>
                Edit Info
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="producer-main">
        <div className="container">
          <div className="producer-hub-menu">
            {menuBtn.map((item: any, index: number) => {
              return (
                <Button
                  key={index}
                  className={`tab-btn ${activeTab === item.id ? "active" : ""}`}
                  onClick={() => setActiveTab(item.id)}
                >
                  {item.title}
                </Button>
              );
            })}
          </div>
          {activeTab === 1 && <Overview />}
          {activeTab === 2 && <MyProduct />}
        </div>
      </div>
    </div>
  );
};

export default ProducerHub;
